import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { ConstantService } from "../../../services/ConstantService";
import { CurrencyTypeService } from "../../../services/CurrencyTypeService";
import { GetCurrencyTypeByIdResponse } from "../../../models/response/currencyType/GetCurrencyTypeByIdResponse";

const CurrencyTypeAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Döviz Cinsi Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const passCardsRef: any = useRef();
    const [currencyTypeId, setCurrencyTypeId] = useState<string | undefined>(undefined);
    const [shortName, setShortName] = useState('');
    const [longName, setLongName] = useState('');
    const [symbol, setSymbol] = useState('');

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                dispatch(storeActivityIndicator(true))

                var response: GetCurrencyTypeByIdResponse = await CurrencyTypeService.getCurrencyTypeById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCurrencyTypeId(response.data.currencyTypeId);
                setShortName(response.data.code);
                setLongName(response.data.name);
                setSymbol(response.data.symbol);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveCurrencyType = async () => {
        try {
            if (Helpers.isEmpty(shortName))
                toast.error('Kodu alanını doldurunuz!')
            else if (Helpers.isEmpty(longName))
                toast.error('Adı alanını doldurunuz!')
            else if (Helpers.isEmpty(symbol))
                toast.error('Sembolü alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddConstantResponse = await ConstantService.addConstant(currencyTypeId, 'CURRENCY', longName, undefined, shortName, symbol, undefined);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Kodu</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={shortName} onChange={(e) => setShortName(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={longName} onChange={(e) => setLongName(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Sembolü</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={symbol} onChange={(e) => setSymbol(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCurrencyType}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CurrencyTypeAdd;